export const CREATED = 'CREATED'
export const MODIFIED = 'MODIFIED'
export const REMOVAL = 'REMOVAL'
export const ERROR = 'ERROR'
export const VALIDATION_ERROR = 'VALIDATION_ERROR'
export const FILE = 'FILE'
